import { useState, useEffect } from 'react';
import getSuggestions from '../../../../services/getSuggestions';

export default function useGetSuggestions(debouncedSearchedTerms, selectedCountry) {

  const [isGetSuggestionsProcessingInProgress, setIsGetSuggestionsProcessingInProgress] = useState(false);
  const [getSuggestionsProcessingError, setGetSuggestionsProcessingError] = useState(null);

  const [partnerIntegratorLevelSuggestions, setPartnerIntegratorLevelSuggestions] = useState(null);
  const [partnerProviderLevelSuggestions, setPartnerProviderLevelSuggestions] = useState(null);
  const [partnerDeveloperLevelSuggestions, setPartnerDeveloperLevelSuggestions] = useState(null);
  const [partnerAdvisorLevelSuggestions, setPartnerAdvisorLevelSuggestions] = useState(null);
  const [partnerIntegratorSpecializationSuggestions, setPartnerIntegratorSpecializationSuggestions] = useState(null);
  const [partnerProviderCiscoPoweredServiceSuggestions, setPartnerProviderCiscoPoweredServiceSuggestions] = useState(null);
  const [partnerNameSuggestions, setPartnerNameSuggestions] = useState(null);
  const [searchedTermsAsPartnerNameSuggestion, setSearchedTermsAsPartnerNameSuggestion] = useState(null);

  function resetSuggestions() {
    setPartnerIntegratorLevelSuggestions(previousValue => null);
    setPartnerProviderLevelSuggestions(previousValue => null);
    setPartnerDeveloperLevelSuggestions(previousValue => null);
    setPartnerAdvisorLevelSuggestions(previousValue => null);
    setPartnerIntegratorSpecializationSuggestions(previousValue => null);
    setPartnerProviderCiscoPoweredServiceSuggestions(previousValue => null);
    setPartnerNameSuggestions(previousValue => null);
    setSearchedTermsAsPartnerNameSuggestion(previousValue => null);
  }

  useEffect(
    () => {
      async function findSuggestions() {
        const suggestions = await getSuggestions(debouncedSearchedTerms, selectedCountry);
        if(!suggestions.hasError) {
          setGetSuggestionsProcessingError(null);

          setPartnerIntegratorLevelSuggestions(previousValue => suggestions.partnerIntegratorLevelSuggestions);
          setPartnerProviderLevelSuggestions(previousValue => suggestions.partnerProviderLevelSuggestions)
          setPartnerDeveloperLevelSuggestions(previousValue => suggestions.partnerDeveloperLevelSuggestions);
          setPartnerAdvisorLevelSuggestions(previousValue => suggestions.partnerAdvisorLevelSuggestions);
          setPartnerIntegratorSpecializationSuggestions(previousValue => suggestions.partnerIntegratorSpecializationSuggestions)
          setPartnerProviderCiscoPoweredServiceSuggestions(previousValue => suggestions.partnerProviderCiscoPoweredServiceSuggestions)
          setPartnerNameSuggestions(previousValue => suggestions.partnerNameSuggestions);
          setSearchedTermsAsPartnerNameSuggestion(previousValue => suggestions.searchedTermsAsPartnerNameSuggestion);
        }
        else {
          setGetSuggestionsProcessingError(suggestions.errorMessage);

          setPartnerIntegratorLevelSuggestions(previousValue => null);
          setPartnerProviderLevelSuggestions(previousValue => null);
          setPartnerDeveloperLevelSuggestions(previousValue => null);
          setPartnerAdvisorLevelSuggestions(previousValue => null);
          setPartnerIntegratorSpecializationSuggestions(previousValue => null);
          setPartnerProviderCiscoPoweredServiceSuggestions(previousValue => null);
          setPartnerNameSuggestions(previousValue => null);
          setSearchedTermsAsPartnerNameSuggestion(previousValue => null);

        }
        setIsGetSuggestionsProcessingInProgress(false);
      }
      if(!!debouncedSearchedTerms && debouncedSearchedTerms.length > 2) {
        setIsGetSuggestionsProcessingInProgress(true);
        findSuggestions();
      }
    },
    [debouncedSearchedTerms, selectedCountry]
  );


  return {
    isGetSuggestionsProcessingInProgress,
    getSuggestionsProcessingError,
    partnerIntegratorLevelSuggestions,
    partnerProviderLevelSuggestions,
    partnerDeveloperLevelSuggestions,
    partnerAdvisorLevelSuggestions,
    partnerIntegratorSpecializationSuggestions,
    partnerProviderCiscoPoweredServiceSuggestions,
    partnerNameSuggestions,
    searchedTermsAsPartnerNameSuggestion,
    resetSuggestions
  }

}
